import { FieldErrors, FieldValues } from "react-hook-form";

export const scrollToFormError = <T extends FieldValues>(
  errors: FieldErrors<T>,
) => {
  const firstErrorKey = errors.data && Object.keys(errors.data)?.[0];
  if (!firstErrorKey) return;

  const element = document.querySelector(
    `[data-error-scroll="${firstErrorKey}"]`,
  );

  if (element) {
    element.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
    setTimeout(() => {
      element.querySelector("input")?.focus();
    }, 500);
  }
};
